import { getTestAttributes, slug } from '@chillibean/component-library';

const withErrorWrap = (Component) => {
  const toReturn = (props) => {
    const { showError, errorMessage, fieldIdentifier = 'field' } = props;
    if (showError) {
      return (
        <div className="form__field-error-container">
          <div className="form__field-error-wrapper">
            <Component {...props} showError={false} />
          </div>
          <div
            className="form__field-error-message"
            {...getTestAttributes(`${slug(fieldIdentifier)}-form-field-error-message`)}
          >
            {errorMessage}
          </div>
        </div>
      );
    }
    return <Component {...props} />;
  };

  toReturn.displayName = 'withErrorWrap';
  return toReturn;
};

export default withErrorWrap;
